// extracted by mini-css-extract-plugin
module.exports = {"main":"CallToAction_main__1bCHi"};